import 'twin.macro'

import PhoneIcon from 'assets/icons/phone-icon.svg?component'
import FacebookIcon from 'assets/icons/socials/facebook.svg?component'
import InstagramIcon from 'assets/icons/socials/instagram.svg?component'
import WhatsappIcon from 'assets/icons/socials/whatsapp.svg?component'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import tw, { TwStyle } from 'twin.macro'

import SVGIcon from '../SvgIcon'
import Typography from '../Typography'
import Heading from '../Typography/Heading'

const Container = ({
  twStyle,
  sidebarContent,
  children
}: {
  twStyle?: TwStyle
  sidebarContent: ReactNode
  children: ReactNode
}) => {
  const { t } = useTranslation('common')
  return (
    <div css={[tw`md:grid grid-cols-[307px 1fr] gap-x-[50px] lg:gap-x-[101px] mt-0 md:mt-8 mb-32`, twStyle]}>
      <div tw='hidden md:block'>
        {sidebarContent}
        <hr tw='my-8 border-grey-middle' />
        <div tw='invisible md:visible flex space-x-6'>
          <div>
            <div tw='flex space-x-2'>
              <PhoneIcon tw='flex-shrink-0' />
              <a href='tel:595' rel='noreferrer'>
                <Heading variant='title2' as='h6'>
                  595
                </Heading>
              </a>
            </div>
            <Typography variant='caption' twStyle={tw`text-grey-dark`}>
              {t('free-call')}
            </Typography>
          </div>
          <div aria-label='socials' tw='flex space-x-2'>
            <a
              href='https://www.instagram.com/bankffin.kz/'
              aria-label='instagram link'
              target='_blank'
              rel='noreferrer'
            >
              <SVGIcon>
                <InstagramIcon tw='flex-shrink-0' />
              </SVGIcon>
            </a>
            <a
              href='https://api.whatsapp.com/send?phone=77761595595'
              aria-label='whatsapp link'
              target='_blank'
              rel='noreferrer'
            >
              <SVGIcon>
                <WhatsappIcon tw='flex-shrink-0' />
              </SVGIcon>
            </a>
            <a href='https://www.facebook.com/bankffin.kz' aria-label='facebook link' target='_blank' rel='noreferrer'>
              <SVGIcon>
                <FacebookIcon tw='flex-shrink-0' />
              </SVGIcon>
            </a>
          </div>
        </div>
      </div>
      {children}
    </div>
  )
}

export default Container
